import {
    removeAllAreaTokens,
    setTokenInLocalStorage,
} from './localStorageHelpers';

const AUTH_AREA_KEY = 'authArea';

export const login = (foto, token, authArea) => {
    sessionStorage.setItem('logged', 'ok');
    if (authArea) {
        sessionStorage.setItem(AUTH_AREA_KEY, authArea);
    } else {
        sessionStorage.removeItem(AUTH_AREA_KEY);
    }
    setTokenInLocalStorage(token, authArea || 'generale');
    localStorage.setItem('fotoProfilo', 'data:image/png;base64, ' + foto);
};
export const loginPersistant = (token) => {
    setTokenInLocalStorage(token, 'generale');
    localStorage.setItem('logged', 'ok');
    sessionStorage.removeItem(AUTH_AREA_KEY);
};

export const logout = () => {
    localStorage.removeItem('logged');
    removeAllAreaTokens();
    sessionStorage.removeItem('logged');
    sessionStorage.removeItem(AUTH_AREA_KEY);
    sessionStorage.removeItem('fotoProfilo');
};

export const isLogin = () => {
    if (sessionStorage.getItem('logged') || localStorage.getItem('logged')) {
        return true;
    }

    return false;
};

export const isLoginArea = (authArea) => {
    return isLogin() && sessionStorage.getItem(AUTH_AREA_KEY) === authArea;
};

export const clearAreaSession = () => {
    sessionStorage.removeItem(AUTH_AREA_KEY);
    sessionStorage.removeItem('logged');
    removeAllAreaTokens();
};

export const getWelcomeByCF = (cf) => {
    // Italian CF encodes day of birth in positions 9-10 (0-indexed):
    // 1-31 male, 41-71 female (day + 40).
    const fallback = 'Benvenuto';
    if (!cf) return fallback;
    const s = String(cf).trim().toUpperCase();
    if (/^KTEC[A-F0-9]{12}$/.test(s)) return fallback;
    if (s.length < 11) return fallback;
    const dayStr = s.slice(9, 11);
    const day = Number.parseInt(dayStr, 10);
    if (!Number.isFinite(day)) return fallback;
    return day > 40 ? 'Benvenuta' : 'Benvenuto';
};
